import * as types from "../types/alertMessageTypes";
// success alerts
export const successAlert = (alerts) => {
  return {
    type: types.SUCCESS_ALERT,
    alerts,
  };
};

export const successAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(successAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};

// warning alerts
export const warningAlert = (alerts) => {
  return {
    type: types.WARNING_ALERT,
    alerts,
  };
};

export const warningAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(warningAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};

// info alerts
export const infoAlert = (alerts) => {
  return {
    type: types.INFO_ALERT,
    alerts,
  };
};

export const infoAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(infoAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};

// error alerts
export const errorAlert = (alerts) => {
  return {
    type: types.ERROR_ALERT,
    alerts,
  };
};

export const errorAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(errorAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};
